import { getCurrentInstance } from '@/composition/vue/compositionApi'
import { TmMissingComponentScopeError } from '@/core/error/tmMissingComponentScopeError'
import { isDev } from '@/utils/system'
import { getMonitoringLoggerService } from '@/core/container/ioc'
import { LogLevel } from '@/core/logger/types'

/**
 * This function is intended to throw an error in dev mode and log a Sentry error in production
 * when it's being called outside a component scope.
 *
 * Why is this important: composables must be called inside either an effectScope, or in a component scope.
 * This is the only way to attach the composable' effect scope to the parent scope and properly
 * create and dispose effects and composable' lifecycle. Otherwise it can lead us to memory leaks
 * and other unexpected behavior.
 */
export const assertComponentScope = (name?: string) => {
  if (!getCurrentInstance()) {
    const errorToThrow = new TmMissingComponentScopeError(
      name
        ? `"${name}" composable must be called inside a component scope.`
        : 'This composable must be called inside a component scope.',
    )

    if (isDev) {
      throw errorToThrow
    } else {
      getMonitoringLoggerService().logAndCapture(errorToThrow, LogLevel.ERROR)
    }
  }
}
